module.exports = {
  lang: 'English',
  login: {
    login: 'Login',
    loginTitle: 'Welcome Sign In',
  },
}
